import { APP_PREFIX_PATH } from 'configs/AppConfig'

import {
  DashboardOutlined,
  DollarCircleOutlined,
  AppstoreOutlined,
  UserSwitchOutlined,
  FundOutlined,
  ProfileOutlined,
  IdcardOutlined,
  DatabaseFilled,
  DownloadOutlined,
  FileImageOutlined,
  TransactionOutlined,
  BoxPlotOutlined,
  TranslationOutlined,
  AuditOutlined,
  UpSquareOutlined,
  FileProtectOutlined,
  OrderedListOutlined,
  PlusSquareOutlined,
  RedoOutlined,
  PlusOutlined,
  BookOutlined
} from '@ant-design/icons';

const dashBoardNavTree = [{
  key: 'dashboards',
  path: `${APP_PREFIX_PATH}/dashboards`,
  title: 'sidenav.dashboard',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'dashboards-home',
      path: `${APP_PREFIX_PATH}/dashboards/dashoardHome`,
      title: 'sidenav.dashboard.home',
      icon: FundOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-draw',
      path: `${APP_PREFIX_PATH}/dashboards/luckyDraw`,
      title: 'sidenav.dashboard.luckyDraw',
      icon: RedoOutlined,
      breadcrumb: false,
      submenu: []
    },
     {
      key: 'dashboards-cashCollection',
      path: `${APP_PREFIX_PATH}/dashboards/cash_Collections`,
      title: 'sidenav.dashboard.cash',
      icon: DollarCircleOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-Unit-list',
      path: `${APP_PREFIX_PATH}/dashboards/unit_List`,
      title: 'sidenav.dashboard.UnitList',
      icon: OrderedListOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-bhadram',
      path: `${APP_PREFIX_PATH}/dashboards/bhadram`,
      title: 'sidenav.dashboard.bhadram',
      icon: BoxPlotOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-bhadram-plus',
      path: `${APP_PREFIX_PATH}/dashboards/bhadram_plus`,
      title: 'sidenav.dashboard.bhadram_plus',
      icon: PlusSquareOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-treatment',
      path: `${APP_PREFIX_PATH}/dashboards/treatment`,
      title: 'sidenav.dashboard.treatment',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-unit-admin',
      path: `${APP_PREFIX_PATH}/dashboards/unitAdmin`,
      title: 'sidenav.dashboard.unitadmin',
      icon: AuditOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-unit-statement',
      path: `${APP_PREFIX_PATH}/dashboards/unitStatement`,
      title: 'sidenav.dashboard.unitstatement',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-unit-statementSamplr',
      path: `${APP_PREFIX_PATH}/dashboards/unitStatementSample`,
      title: 'sidenav.dashboard.unitstatementSample',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'dashboards-Vyaparotsavam',
      path: `${APP_PREFIX_PATH}/dashboards/Vyaparotsavam`,
      title: 'sidenav.dashboard.Vyaparotsavam',
      icon: ProfileOutlined,
      breadcrumb: false,
      submenu: []
    },
    // {
    //   key: 'dashboards-admin',
    //   path: `${APP_PREFIX_PATH}/dashboards/admin`,
    //   title: 'sidenav.dashboard.admin',
    //   icon: RadarChartOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // }
  ]
}]

const bhadramNavTree = [{
  key: 'bhadram',
  path: `${APP_PREFIX_PATH}/bhadram`,
  title: 'sidenav.bhadram',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'bhadram-subscriber',
      path: `${APP_PREFIX_PATH}/bhadram/subscriberList`,
      title: 'sidenav.bhadram.subscriberList',
      icon: PlusOutlined,
      breadcrumb: false,
      submenu: []
    },
    // {
    //   key: 'bhadram-draw',
    //   path: `${APP_PREFIX_PATH}/bhadram/luckyDraw`,
    //   title: 'sidenav.dashboard.luckyDraw',
    //   icon: RedoOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    //  {
    //   key: 'bhadram-cashCollection',
    //   path: `${APP_PREFIX_PATH}/bhadram/cash_Collections`,
    //   title: 'sidenav.dashboard.cash',
    //   icon: DollarCircleOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'bhadram-Unit-list',
    //   path: `${APP_PREFIX_PATH}/bhadram/unit_List`,
    //   title: 'sidenav.dashboard.UnitList',
    //   icon: OrderedListOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'bhadram-bhadram',
    //   path: `${APP_PREFIX_PATH}/bhadram/bhadram`,
    //   title: 'sidenav.dashboard.bhadram',
    //   icon: BoxPlotOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'bhadram-bhadram-plus',
    //   path: `${APP_PREFIX_PATH}/bhadram/bhadram_plus`,
    //   title: 'sidenav.dashboard.bhadram_plus',
    //   icon: PlusSquareOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'bhadram-unit-admin',
    //   path: `${APP_PREFIX_PATH}/bhadram/unitAdmin`,
    //   title: 'sidenav.dashboard.unitadmin',
    //   icon: AuditOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'bhadram-unit-statement',
    //   path: `${APP_PREFIX_PATH}/bhadram/unitStatement`,
    //   title: 'sidenav.dashboard.unitstatement',
    //   icon: FileProtectOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'bhadram-unit-statementSamplr',
    //   path: `${APP_PREFIX_PATH}/bhadram/unitStatementSample`,
    //   title: 'sidenav.dashboard.unitstatementSample',
    //   icon: FileProtectOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // },
    // {
    //   key: 'bhadram-Vyaparotsavam',
    //   path: `${APP_PREFIX_PATH}/bhadram/Vyaparotsavam`,
    //   title: 'sidenav.dashboard.Vyaparotsavam',
    //   icon: ProfileOutlined,
    //   breadcrumb: false,
    //   submenu: []
    // }
  ]
}]

const appsNavTree = [{
  key: 'apps',
  path: `${APP_PREFIX_PATH}/apps`,
  title: 'sidenav.apps',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'apps-memers',
      path: `${APP_PREFIX_PATH}/apps/members`,
      title: 'sidenav.apps.members',
      icon: UserSwitchOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'apps-members_directory',
      path: `${APP_PREFIX_PATH}/apps/directory`,
      title: 'sidenav.apps.member_directory',
      icon: ProfileOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'apps-members_directorySingle',
      path: `${APP_PREFIX_PATH}/apps/DirectorySingle`,
      title: 'sidenav.apps.member_directorySingle',
      icon: ProfileOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'apps-members_idCards',
      path: `${APP_PREFIX_PATH}/apps/idCard`,
      title: 'sidenav.apps.idCards',
      icon: IdcardOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const kshemanidhiNavTree = [{
  key: 'Kshemanidhi',
  path: `${APP_PREFIX_PATH}/Kshemanidhi`,
  title: 'sidenav.Kshemanidhi',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'Kshemanidhi-members',
      path: `${APP_PREFIX_PATH}/Kshemanidhi/members`,
      title: 'sidenav.Kshemanidhi.members',
      icon: UserSwitchOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'Kshemanidhi-pensioner',
      path: `${APP_PREFIX_PATH}/Kshemanidhi/pensions`,
      title: 'sidenav.Kshemanidhi.Pensioner',
      icon: ProfileOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const details = [{
  key: 'details',
  path: `${APP_PREFIX_PATH}/details`,
  title: 'sidenav.Details',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'details-news',
      path: `${APP_PREFIX_PATH}/details/news`,
      title: 'sidenav.Details.news',
      icon: DatabaseFilled,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'details-boardMembers',
      path: `${APP_PREFIX_PATH}/details/boardMembers`,
      title: 'sidenav.Details.boardMembers',
      icon: UserSwitchOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'details-downloads',
      path: `${APP_PREFIX_PATH}/details/downloads`,
      title: 'sidenav.Details.downloads',
      icon: DownloadOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'details-Gallery',
      path: `${APP_PREFIX_PATH}/details/gallery`,
      title: 'sidenav.Details.gallery',
      icon: FileImageOutlined,
      breadcrumb: false,
      submenu: []
    }
    ,
    {
      key: 'details-banner',
      path: `${APP_PREFIX_PATH}/details/banner`,
      title: 'sidenav.Details.banner',
      icon: UpSquareOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const onlineTransaction = [{
  key: 'online',
  path: `${APP_PREFIX_PATH}/online`,
  title: 'sidenav.online',
  icon: AppstoreOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'online-transaction',
      path: `${APP_PREFIX_PATH}/online/transactions`,
      title: 'sidenav.online.bdrm',
      icon: TransactionOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'online-plus-transaction',
      path: `${APP_PREFIX_PATH}/online/plusTransactions`,
      title: 'sidenav.online.bdrm.plus',
      icon: TransactionOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'online-UPIPayment',
      path: `${APP_PREFIX_PATH}/online/UPI_payments`,
      title: 'sidenav.online.UPI',
      icon: TranslationOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'online-transactionReport',
      path: `${APP_PREFIX_PATH}/online/transactionReport`,
      title: 'sidenav.online.txnReport',
      icon: FileProtectOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'online-bulk',
      path: `${APP_PREFIX_PATH}/online/bulk_payment`,
      title: 'sidenav.online.bulk',
      icon: TransactionOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'online-collection-report',
      path: `${APP_PREFIX_PATH}/online/collection_report`,
      title: 'sidenav.online.collnReport',
      icon: BookOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'online-bhcollection-report',
      path: `${APP_PREFIX_PATH}/online/bhCollection_report`,
      title: 'sidenav.online.bhcollnReport',
      icon: BookOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'online-payment-details',
      path: `${APP_PREFIX_PATH}/online/payment-details`,
      title: 'sidenav.online.paymentDetails',
      icon: DollarCircleOutlined,
      breadcrumb: false,
      submenu: []
    }
  ]
}]

const navigationConfig = [
  ...dashBoardNavTree,
  ...bhadramNavTree,
  ...onlineTransaction,
  ...appsNavTree,
  ...kshemanidhiNavTree,
  ...details,
]

export default navigationConfig;
